<template>
  <div>
    <b-button @click="open" variant="primary">Abrir</b-button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    async created () {
    },
    methods: {
      open () {
        window.open('/login','winname',"directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=400,height=350");
      },
    }
  }
</script>